import { GET_POWERBALLBETTINGLIST, SET_BETDATA, SET_BETTYPE, SET_POWERBALL_RATES, SET_MINIGAME_TYPE, SET_MINICHECK, SET_ALLMINIDATA } from '../actions/types';

const initialState = {
   type: 0,
   bettingList: [],      // minigame betting list data
   data: {
      odd_key: '',
      rate: 0,
      name: '-'
   },
   rates: {
      normal: {
         evenOdd: 1,
         overUnder: 1,
         big: 1,
         medium: 1,
         small: 1,
         odd: 1,
         even: 1,
         nugurileft: 1,
         nuguriright: 1,
         line3: 1,
         line4: 1,
         left: 1,
         right: 1,
         homerun: 1,
         strike: 1
      },
      power: {
         evenOdd: 1,
         overUnder: 1
      },
      strike: {
         left: 1,
         right: 1,
         middle: 1
      },
      homerun: {
         left: 1,
         right: 1,
         middle: 1
      },
      kicker: {
         kicker_left: 1,
         kicker_right: 1
      },
      keeper: {
         keeper_left: 1,
         keeper_right: 1
      },
      goal: {
         goal_left: 1,
         goal_right: 1
      }
   },
   btn_status: {
      normal_evenodd: true,
      normal_overunder: true,
      normal_sum: true,
      power_evenodd: true,
      power_overunder: true,
      normal_leftright: true,
      normal_line: true,
      normal_strike: true,
      normal_homerun: true,
      strike_homerun: true,
      normal_kicker: false,
      normal_keeper: false,
      normal_goal: false
   },
   state: {},
   leftTime: "",
   miniCheck: true,
}

export default function (state = initialState, action) {
   switch (action.type) {
      case SET_MINIGAME_TYPE:
         return {
            ...state,
            type: action.payload
         }
      case GET_POWERBALLBETTINGLIST:
         return {
            ...state,
            bettingList: action.payload
         }
      case SET_BETDATA:
         return {
            ...state,
            data: action.payload
         }
      case SET_BETTYPE:
         // //console.log(action.payload)
         return {
            ...state,
            type: action.payload
         }
      case SET_POWERBALL_RATES:
         // //console.log("=-=========--=", { ...state.rates, ...action.payload.rates})
         return {
            ...state,
            rates: { ...state.rates, ...action.payload.rates },
            state: action.payload.state,
            leftTime: action.payload.leftTime,
            btn_status: action.payload.btn_status
         }
      case SET_MINICHECK:
         return {
            ...state,
            miniCheck: action.payload
         }
      case SET_ALLMINIDATA:
         return {
            ...state,
            allminiData: action.payload
         }
      default:
         return state;
   }
}


// WEBPACK FOOTER //
// ./src/common/reducers/miniReducer.js